import { Stack, Typography } from "@mui/material";

import { useNavigate } from "react-router-dom";

export default function Main() {
  const navigate = useNavigate();

  return (
    <Stack sx={sx.wrapper}>
      <Typography>No Page</Typography>
      <Typography onClick={() => navigate("/")} sx={sx.btn}>
        Home
      </Typography>
    </Stack>
  );
}

const sx = {
  wrapper: {
    width: 1,
    height: "100vh",
    alignItems: "center",
    justifyContent: "center",
  },
  btn: {
    cursor: "pointer",
    "&:hover": { backgroundColor: "lightgrey" },
    p: 1,
  },
};
